import { Col, Collapse, message, Skeleton, Tooltip, Row, Tag, Form, Input, Button, Result } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { BsCheckCircle, BsExclamationCircle, BsInfoCircle, BsXCircle } from 'react-icons/bs';
import { GetCampaignCreative } from '../../../../apis/Admin/Campaigns/Creatives/GetCampaignCreative';
import { useGlobalState } from '../../../../store/state';
import { CreativePostStatusChange } from '../../../../apis/Admin/Campaigns/Creatives/CreativePostStatusChange';

const { Panel } = Collapse;
const { TextArea } = Input;
const { Item, useForm } = Form;
const CreativesApprovalsHolder = ({ influId, resetAllCards }) => {
  const [user] = useGlobalState('user');
  const params = useParams();
  const [statusForm] = useForm();
  const [loading, setLoading]=useState(true);
  const [creativeList, setCreativeList]=useState([]);
  const getCampaignCreatives = () =>{
    GetCampaignCreative(user.accessToken, params.campaignId, influId).then(({ response, status }) =>{
      console.log('response from camps ++', response);
      if (status === 200) {
        setCreativeList([...response]);
        setLoading(false);
        resetAllCards(); // all influencer cards will re-fetch
      } else {
        message.error('There is some issue while getting data');
      }
    });
  };
  useEffect(() =>{
    getCampaignCreatives();
  }, []);

  // const changeCreativeStatus = (data) =>{
  //     console.log("submission data",data)
  // }
  const changeCreativeStatus = (id, creativeId, status) =>{
    // console.log("submission data",statusForm.getFieldsValue())
    // console.log("submission data===>?",{id,creativeId,status})
    // console.log("submission message ===>?",statusForm.getFieldValue(`message_${id}`) )

    const _data = {
      // status: "",
      // message: "",
      creativedata: [
        {
          id: id,
          status: status,
          message: statusForm.getFieldValue(`message_${id}`),
        },
      ],
    };

    console.log('_data', _data);
    CreativePostStatusChange(user.accessToken, creativeId, _data).then(({ response, status })=>{
      console.log('post status', response);
      if (status === 200) {
        message.success('status changed Successfully');
        getCampaignCreatives();
      } else {
        message.success('Some error while updating status');
      }
    });
  };
  // const approveCreative = (formName) =>{
  //     console.log("submission data",statusForm.getFieldsValue())
  // }
  return (
    <div>
      <div className="campaign_details pt-1">
        {loading ? (
          <div>
            <Skeleton active
              paragraph={{ rows: 6 }}/>
          </div>
        ):(
        // <Form
        //     layout="vertical"
        //     form={statusForm}
        //     onFinish={changeCreativeStatus}
        //     className=""
        //     name="adminSubmit"
        // >
          creativeList.length > 0 ? (
            <Collapse
              className="acc_campaign mb-2 common_collapse"
              showArrow={false}
              defaultActiveKey={[1, 2, 3, 4]}
            >
              {creativeList.map(({ format, creativedata, asset, status, ...listRest }, index) => (
                <Panel key={index}
                  showArrow={false}
                  header={
                    <h3 >Creative #{index + 1}</h3>
                  }
                >
                  <ul className="cc_preview_each_basics">
                    <li>
                      <p>ID</p>
                      <h6>{listRest._id}</h6>
                    </li>
                    <li>
                      <p>No. of posts</p>
                      <h6>{creativedata.length}</h6>
                    </li>
                  </ul>
                  {
                    creativedata.map(({ asset, content, title, _id, posturl, adminMessage, ...other }, i)=>{
                      if (other.status === 'accepted' || other.status === 'review') {
                        return (
                          <div key={_id}
                            className="creativePosts_each approved text-left">
                            <div className="creativePosts_each_stat">
                              {
                                other.status ==='accepted' ?(
                                  <Tag icon={<BsCheckCircle/>}
                                    color='success'>Accepted</Tag>
                                ):(
                                  <Tag icon={<BsExclamationCircle/>}
                                    color='warning'>In Review</Tag>
                                )
                              }
                            </div>
                            <div className="creativePosts_each_count float-right">
                              <span>{i+1}</span>/{creativedata.length}
                            </div>
                            <Row gutter={12}
                              className="">
                              <Col span={10}>
                                <a className="approved_data_asset"
                                  data-fancybox={_id}
                                  href={asset.url}>
                                  <img src={asset.url}
                                    className="img-fluid"
                                    alt={asset.filename} />
                                </a>
                              </Col>
                              <Col span={14}>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post title</div>
                                  <h6 className="approved_data--title">{title}</h6>
                                </div>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post Description</div>
                                  <h6 className="approved_data--para">{content}</h6>
                                </div>
                                {
                                  posturl !== ''?
                                    <div className="approved_data text-left">
                                      <div className="approved_data--label">Post Link Provided</div>
                                      <h6 className="approved_data--para">{posturl}</h6>
                                    </div>:
                                    null
                                }
                                {
                                  other.status === 'review' ?
                                    <div>
                                      <Form
                                        layout="vertical"
                                        form={statusForm}
                                        // onFinish={changeCreativeStatus}
                                        className=""
                                        name={'adminSubmit'+_id}
                                      >
                                        <Item
                                          name={`message_${_id}`}
                                          label="Add your Comments"
                                        >
                                          <TextArea className="common_input"
                                            row={5}/>
                                        </Item>
                                        <Item className="text-right">
                                          <Button
                                            className="common_button outlined small danger mr-3"
                                            onClick={() => changeCreativeStatus(_id, listRest._id, 'rejected')}
                                          >Reject</Button>
                                          <Button
                                            onClick={() => changeCreativeStatus(_id, listRest._id, 'accepted')}
                                            className="common_button small"
                                          >Approve</Button>
                                        </Item>
                                      </Form>
                                    </div>:
                                    null
                                }
                              </Col>
                            </Row>
                          </div>
                        );
                      } else if (other.status === 'rejected') {
                        return (
                          <div key={_id}
                            className="creativePosts_each reject">
                            <div className="creativePosts_each_stat">
                              <Tooltip
                                title="This post rejected by admin Team once"
                              >
                                <BsInfoCircle className="mr-2"/>
                              </Tooltip>
                              <Tag icon={<BsXCircle/>}
                                color="error">Rejected</Tag>
                            </div>
                            <div className="creativePosts_each_count">
                              <span>{i+1}</span>/{creativedata.length}
                            </div>
                            <Row gutter={12}
                              className="text-left">
                              <Col span={24}>
                                {/* <hr /> */}
                                <h5 className="reject_title m-0 pb-2">Reason for Rejections</h5>
                                <p className="m-0"
                                  style={{ whiteSpace: 'pre-line' }}>{adminMessage || 'N/A'}</p>
                              </Col>
                              <Col span={24}>
                                <hr />
                                <h5 className="reject_title"
                                  style={{ opacity: 0.7 }}>Old Submission</h5>
                              </Col>
                              <Col span={10}
                                style={{ opacity: 0.7 }}>
                                <a className="approved_data_asset"
                                  data-fancybox={_id}
                                  href={asset.url}>
                                  <img src={asset.url}
                                    className="img-fluid"
                                    alt={asset.filename} />
                                </a>
                              </Col>
                              <Col span={14}
                                style={{ opacity: 0.7 }}>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post title</div>
                                  <h6 className="approved_data--title"
                                    style={{ color: '#333' }}>{title}</h6>
                                </div>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post Description</div>
                                  <h6 className="approved_data--para">{title}</h6>
                                </div>
                              </Col>


                            </Row>
                          </div>
                        );
                      }
                    })
                  }
                </Panel>
              ))}
            </Collapse>
          ):(
            <Result
              title="No Creatives Submitted"
            />
          )
        // </Form>
        )}
      </div>
    </div>
  );
};

export default CreativesApprovalsHolder;
